import allSettled from 'promise.allsettled'

import { getPayloadFromResponse } from 'src/utils/api/core'
import {
  addPilotageTug,
  getPilotageTugs,
  removePilotageTug,
} from 'src/utils/api/tugs'

import { SYNC_ENTITY_TYPES } from 'src/utils/constants'

export const sync = async syncItem => {
  const {
    entity: { pilotageUuid, data },
  } = syncItem
  

  let tugLinesOnServerResponse = await getPilotageTugs(pilotageUuid)
  let tugLinesOnServer = getPayloadFromResponse(tugLinesOnServerResponse)

  // Flatten staged structure: { [stageUuid]: { [lineNumber]: pilotageTug } }
  let localTugsFlat = [];
  if (data && typeof data === 'object') {
    Object.keys(data).forEach(stageUuid => {
      const stageTugs = data[stageUuid];
      if (stageTugs && typeof stageTugs === 'object') {
        Object.keys(stageTugs).forEach(lineNumber => {
          localTugsFlat.push({
            ...stageTugs[lineNumber],
            stage: { uuid: stageUuid },
            lineNumber: Number(lineNumber),
          });
        });
      }
    });
  }

  // Compare by stageUuid+lineNumber
  const key = (tug) => `${tug.stage && tug.stage.uuid}_${tug.lineNumber}`;
  const localMap = Object.fromEntries(localTugsFlat.map(tug => [key(tug), tug]));
  const serverMap = Object.fromEntries((tugLinesOnServer || []).map(tug => [key(tug), tug]));
  const allKeys = Array.from(new Set([...Object.keys(localMap), ...Object.keys(serverMap)]));

  // Remove tugs that are on server but not in local
  const resultsDelete = await allSettled(
    allKeys.reduce((requests, k) => {
      if (serverMap[k] && !localMap[k]) {
        return [...requests, removePilotageTug(serverMap[k].uuid)];
      }
      return requests;
    }, [])
  );
  const firstRejectedResultDelete = resultsDelete.find((result) => result.status === 'rejected');
  if (firstRejectedResultDelete) {
    return Promise.reject(new Error(`Failed to delete pilotage tug: ${firstRejectedResultDelete.reason}`));
  }

  // Add tugs that are in local but not on server, or changed
  const resultsAdd = await allSettled(
    allKeys.reduce((requests, k) => {
      if (localMap[k] && (!serverMap[k] || localMap[k].tug.uuid !== (serverMap[k].tug && serverMap[k].tug.uuid))) {
        const tugLine = localMap[k];
        return [
          ...requests,
          addPilotageTug(pilotageUuid, tugLine.tug.uuid, tugLine.lineNumber, tugLine.stage && tugLine.stage.uuid),
        ];
      }
      return requests;
    }, [])
  );
  const firstRejectedResultAdd = resultsAdd.find((result) => result.status === 'rejected');
  if (firstRejectedResultAdd) {
    return Promise.reject(new Error(`Failed to add pilotage tug: ${firstRejectedResultAdd.reason}`));
  }

  tugLinesOnServerResponse = await getPilotageTugs(pilotageUuid);
  tugLinesOnServer = getPayloadFromResponse(tugLinesOnServerResponse);
  return Promise.resolve(tugLinesOnServer);
}

export const createSyncUuid = pilotageUuid =>
  `${pilotageUuid}-${SYNC_ENTITY_TYPES.PILOTAGE_TUGS}`

export default sync
